<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "monthly",
    data() {
        return {
            params: {
                json: 0,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '跨境 月报')
        this.$store.dispatch('getText')
    }
}
</script>